import { useState, useEffect } from "react";
import "./Portfolio.css";
import photo from "./profile.jpg";

const DATA = {
  name: "Taifur Ahmad",
  title: "MERN Stack Developer",
  phone: "+91-9893274291",
  email: "taifurahmad24@gmail.com",
  linkedin: "https://www.linkedin.com/in/taifur-ahmad-558a29341",
  github: "https://github.com/taifur1234",
  portfolio: "https://portfolio-tan-omega-73.vercel.app",
  location: "Khargone, Madhya Pradesh, India",
  about:
    "MERN Stack Developer with hands-on experience building full-stack web applications using React.js, Node.js, Express.js, MongoDB, and JavaScript. Experienced in REST APIs, authentication, responsive UI, database design, and deploying production-ready applications.",
  experience: [
    {
      company: "Digital Savers Pvt. Ltd.",
      role: "Junior Developer",
      duration: "April 2025 - December 2025",
      location: "Khargone, Madhya Pradesh",
      achievements: [
        "Developed and maintained full-stack web applications using React.js, Node.js, Express.js, and MongoDB.",
        "Built responsive frontend interfaces and integrated REST APIs for authentication, CRUD operations, and ticket booking.",
        "Implemented authentication, role-based access control, and resolved bugs using Git and GitHub.",
      ],
    },
  ],
  education: [
    {
      degree: "Bachelor of Computer Applications (BCA)",
      college: "Abhyuday University",
      year: "2023 - 2026",
      result: "CGPA: 6.4",
    },
  ],
  skills: [
    "React.js",
    "JavaScript (ES6+)",
    "HTML5",
    "CSS3",
    "Tailwind CSS",
    "Node.js",
    "Express.js",
    "REST APIs",
    "MongoDB",
    "Git",
    "GitHub",
  ],
  projects: [
    {
      name: "Road Safety & Black Spot Mapping Platform",
      desc: "Built a road safety platform that identifies accident-prone black spots, displays safer routes, and supports admin verification, user reporting, route history, and REST APIs.",
      tech: ["React.js", "Node.js", "Express.js", "MongoDB", "Leaflet", "OpenStreetMap"],
      link: "https://github.com/taifur1234",
    },
    {
      name: "Restaurant Table Reservation System",
      desc: "Developed an online table reservation system with real-time availability, booking conflict detection, menu management, and an admin dashboard.",
      tech: ["React.js", "Node.js", "Express.js", "MongoDB"],
      link: "https://github.com/taifur1234",
    },
    {
      name: "Event Management & Ticket Booking System",
      desc: "Built an event booking platform with authentication, ticket booking workflows, and admin management for event operations.",
      tech: ["React.js", "Node.js", "Express.js", "MongoDB"],
      link: "https://github.com/taifur1234",
    },
    {
      name: "AI Interviewer",
      desc: "Developed an AI-powered mock interview platform with instant feedback, interview history, authentication, and Gemini API integration.",
      tech: ["React.js", "Node.js", "Express.js", "MongoDB", "Gemini API"],
      link: "https://github.com/taifur1234",
    },
    {
      name: "E-Commerce Frontend Website",
      desc: "Built a responsive e-commerce frontend with product listing, category filtering, shopping cart, add-to-cart flow, chatbot integration, reusable components, and modern UI/UX practices.",
      tech: ["React.js", "JavaScript", "HTML5", "CSS3"],
      link: "https://github.com/taifur1234",
    },
  ],
  achievements: [
    "Built multiple MERN stack applications solving real-world problems.",
    "Deployed applications using Netlify, Render, and Vercel.",
  ],
};

function useScrollAnimation() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll(".animate-on-scroll").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

export default function App() {
  const [dark, setDark] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  useScrollAnimation();

  useEffect(() => {
    const sections = ["home", "about", "skills", "experience", "projects", "education", "contact"];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActiveSection(e.target.id);
        });
      },
      { threshold: 0.4 }
    );

    sections.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  const navLinks = ["home", "about", "skills", "experience", "projects", "education", "contact"];

  return (
    <div className={`app ${dark ? "dark" : "light"}`}>
      <nav className="navbar">
        <div className="nav-logo" onClick={() => scrollTo("home")}>
          <span className="logo-text">TA</span>
        </div>
        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          {navLinks.map((n) => (
            <li key={n}>
              <button
                className={`nav-btn ${activeSection === n ? "active" : ""}`}
                onClick={() => scrollTo(n)}
              >
                {n.charAt(0).toUpperCase() + n.slice(1)}
              </button>
            </li>
          ))}
        </ul>
        <div className="nav-right">
          <button
            className="theme-toggle"
            onClick={() => setDark(!dark)}
            aria-label={dark ? "Switch to light theme" : "Switch to dark theme"}
          >
            {dark ? <SunIcon /> : <MoonIcon />}
          </button>
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      <section id="home" className="hero">
        <div className="hero-bg">
          <div className="hero-blob blob1"></div>
          <div className="hero-blob blob2"></div>
          <div className="grid-overlay"></div>
        </div>
        <div className="hero-content">
          <div className="hero-badge animate-on-scroll">Available for Opportunities</div>
          <h1 className="hero-name animate-on-scroll">
            {DATA.name.split(" ").map((w, i) => (
              <span key={i} className="name-word" style={{ animationDelay: `${i * 0.15}s` }}>
                {w}
              </span>
            ))}
          </h1>
          <div className="hero-title animate-on-scroll">
            <span className="title-text">{DATA.title}</span>
          </div>
          <p className="hero-location animate-on-scroll">
            <LocationIcon /> {DATA.location}
          </p>
          <div className="hero-actions animate-on-scroll">
            <button className="btn-primary" onClick={() => scrollTo("projects")}>
              View Projects
            </button>
            <button className="btn-secondary" onClick={() => scrollTo("contact")}>
              Get In Touch
            </button>
          </div>
          <div className="hero-social animate-on-scroll">
            <a href={DATA.github} target="_blank" rel="noreferrer" className="social-link">
              <GithubIcon /> GitHub
            </a>
            <a href={DATA.linkedin} target="_blank" rel="noreferrer" className="social-link">
              <LinkedinIcon /> LinkedIn
            </a>
            <a href={DATA.portfolio} target="_blank" rel="noreferrer" className="social-link">
              <GlobeIcon /> Portfolio
            </a>
            <a href={`mailto:${DATA.email}`} className="social-link">
              <MailIcon /> Email
            </a>
          </div>
        </div>
        <div className="scroll-hint animate-on-scroll">
          <span>Scroll</span>
          <div className="scroll-line"></div>
        </div>
      </section>

      <section id="about" className="section about-section">
        <div className="container">
          <SectionHeader label="About" title="Who I Am" />
          <div className="about-grid animate-on-scroll">
            <div className="about-avatar">
              <div className="avatar-ring">
                <div className="avatar-initials">
                  <img src={photo} alt="Taifur Ahmad profile" />
                </div>
              </div>
              <div className="avatar-glow"></div>
            </div>
            <div className="about-text">
              <p className="about-para">{DATA.about}</p>
              <div className="about-stats">
                <StatCard number="9 Mo" label="Work Experience" />
                <StatCard number="5+" label="Projects Built" />
                <StatCard number="22" label="Technical Skills" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="skills" className="section skills-section">
        <div className="container">
          <SectionHeader label="Skills" title="Tech Stack" />
          <div className="skills-grid animate-on-scroll">
            {DATA.skills.map((skill, i) => (
              <div key={skill} className="skill-chip" style={{ animationDelay: `${i * 0.06}s` }}>
                <span className="skill-dot"></span>
                {skill}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="experience" className="section experience-section">
        <div className="container">
          <SectionHeader label="Experience" title="Work History" />
          <div className="timeline">
            {DATA.experience.map((exp, i) => (
              <div key={i} className="timeline-item animate-on-scroll">
                <div className="timeline-dot"></div>
                <div className="timeline-card">
                  <div className="exp-header">
                    <div>
                      <h3 className="exp-role">{exp.role}</h3>
                      <p className="exp-company">{exp.company}</p>
                      <p className="exp-location">{exp.location}</p>
                    </div>
                    <span className="exp-duration">{exp.duration}</span>
                  </div>
                  <ul className="exp-achievements">
                    {exp.achievements.map((a, j) => (
                      <li key={j}>
                        <span className="ach-bullet">-</span>
                        {a}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="projects" className="section projects-section">
        <div className="container">
          <SectionHeader label="Projects" title="What I've Built" />
          <div className="projects-grid">
            {DATA.projects.map((proj, i) => (
              <div
                key={proj.name}
                className="project-card"
                style={{ animationDelay: `${i * 0.1}s` }}
              >
                <div className="project-top">
                  <div className="project-icon">
                    <CodeIcon />
                  </div>
                  <a href={proj.link} target="_blank" rel="noreferrer" className="project-ext" aria-label={`${proj.name} GitHub`}>
                    <ExtIcon />
                  </a>
                </div>
                <h3 className="project-name">{proj.name}</h3>
                <p className="project-desc">{proj.desc}</p>
                <div className="project-techs">
                  {proj.tech.map((t) => (
                    <span key={t} className="tech-tag">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="education" className="section education-section">
        <div className="container">
          <SectionHeader label="Education" title="Academic Background" />
          <div className="edu-grid animate-on-scroll">
            {DATA.education.map((edu) => (
              <div key={edu.degree} className="edu-card">
                <div className="edu-icon">
                  <GraduationIcon />
                </div>
                <div className="edu-info">
                  <h3 className="edu-degree">{edu.degree}</h3>
                  <p className="edu-college">{edu.college}</p>
                  <div className="edu-meta">
                    {edu.year && <span className="edu-year">{edu.year}</span>}
                    <span className="edu-result">{edu.result}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="achievement-list animate-on-scroll">
            {DATA.achievements.map((achievement) => (
              <div key={achievement} className="achievement-item">
                <CheckIcon />
                <span>{achievement}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="contact" className="section contact-section">
        <div className="container">
          <SectionHeader label="Contact" title="Let's Connect" />
          <div className="contact-wrapper animate-on-scroll">
            <p className="contact-sub">
              I am open to new opportunities, collaborations, and MERN stack projects. Let's build something useful together.
            </p>
            <div className="contact-cards">
              <a href={`tel:${DATA.phone.replace(/-/g, "")}`} className="contact-card">
                <PhoneIcon />
                <span>{DATA.phone}</span>
              </a>
              <a href={`mailto:${DATA.email}`} className="contact-card">
                <MailIcon />
                <span>{DATA.email}</span>
              </a>
              <a href={DATA.linkedin} target="_blank" rel="noreferrer" className="contact-card">
                <LinkedinIcon />
                <span>LinkedIn Profile</span>
              </a>
              <a href={DATA.github} target="_blank" rel="noreferrer" className="contact-card">
                <GithubIcon />
                <span>GitHub Profile</span>
              </a>
              <a href={DATA.portfolio} target="_blank" rel="noreferrer" className="contact-card">
                <GlobeIcon />
                <span>Live Portfolio</span>
              </a>
              <div className="contact-card no-link">
                <LocationIcon />
                <span>{DATA.location}</span>
              </div>
            </div>
            <a href={`mailto:${DATA.email}`} className="btn-primary contact-btn">
              Send Me an Email -&gt;
            </a>
          </div>
        </div>
      </section>

      <footer className="footer">
        <p>
          Designed & Built by <span className="footer-name">Taifur Ahmad</span>
        </p>
        <p className="footer-copy">Copyright {new Date().getFullYear()} All rights reserved.</p>
      </footer>
    </div>
  );
}

function SectionHeader({ label, title }) {
  return (
    <div className="section-header animate-on-scroll">
      <span className="section-label">{label}</span>
      <h2 className="section-title">{title}</h2>
      <div className="section-line"></div>
    </div>
  );
}

function StatCard({ number, label }) {
  return (
    <div className="stat-card">
      <span className="stat-number">{number}</span>
      <span className="stat-label">{label}</span>
    </div>
  );
}

function GithubIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 0C5.37 0 0 5.37 0 12c0 5.3 3.44 9.8 8.2 11.38.6.11.82-.26.82-.58v-2.03c-3.34.72-4.04-1.61-4.04-1.61-.55-1.39-1.34-1.76-1.34-1.76-1.09-.74.08-.73.08-.73 1.2.09 1.84 1.24 1.84 1.24 1.07 1.83 2.81 1.3 3.5 1 .1-.78.42-1.3.76-1.6-2.67-.3-5.47-1.33-5.47-5.93 0-1.31.47-2.38 1.24-3.22-.13-.3-.54-1.52.12-3.18 0 0 1.01-.32 3.3 1.23a11.5 11.5 0 0 1 3-.4c1.02 0 2.04.14 3 .4 2.28-1.55 3.29-1.23 3.29-1.23.66 1.66.25 2.88.12 3.18.77.84 1.24 1.91 1.24 3.22 0 4.61-2.81 5.63-5.49 5.92.43.37.82 1.1.82 2.22v3.29c0 .32.21.7.83.58C20.57 21.8 24 17.3 24 12c0-6.63-5.37-12-12-12z" />
    </svg>
  );
}

function LinkedinIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.95v5.66H9.36V9h3.41v1.56h.05c.47-.9 1.63-1.85 3.36-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM3.56 20.45h3.56V9H3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0z" />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.91.33 1.79.62 2.64a2 2 0 0 1-.45 2.11L8.09 9.66a16 16 0 0 0 6.25 6.25l1.19-1.19a2 2 0 0 1 2.11-.45c.85.29 1.73.5 2.64.62A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}

function GlobeIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <path d="M2 12h20" />
      <path d="M12 2a15.3 15.3 0 0 1 0 20" />
      <path d="M12 2a15.3 15.3 0 0 0 0 20" />
    </svg>
  );
}

function LocationIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

function GraduationIcon() {
  return (
    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="m22 10-10-5-10 5 10 5 10-5z" />
      <path d="M6 12v5c3 2 9 2 12 0v-5" />
      <path d="M22 10v6" />
    </svg>
  );
}

function CheckIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}

function SunIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2" />
      <path d="M12 20v2" />
      <path d="m4.93 4.93 1.41 1.41" />
      <path d="m17.66 17.66 1.41 1.41" />
      <path d="M2 12h2" />
      <path d="M20 12h2" />
      <path d="m6.34 17.66-1.41 1.41" />
      <path d="m19.07 4.93-1.41 1.41" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M12 3a6 6 0 0 0 9 7.5A9 9 0 1 1 12 3z" />
    </svg>
  );
}

function CodeIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <polyline points="16 18 22 12 16 6" />
      <polyline points="8 6 2 12 8 18" />
    </svg>
  );
}

function ExtIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  );
}
